import home from "../../components/pages/home";
import donateBlood from "../../components/pages/donateBlood/donateBlood";
import dbChoiceDonationLocation from "../../components/pages/donateBlood/dbChoiceDonationLocation";
import dbBookingAppointment from "../../components/pages/donateBlood/dbBookingAppointment";
import myDonations from "../../components/pages/myDonations";
import previousDonations from "../../components/pages/previousDonations";
import rewardsStore from "../../components/pages/rewards/rewardsStore";
import rwDescriptionOrder from "../../components/pages/rewards/rwDescriptionOrder";
import rwOrder from "../../components/pages/rewards/rwOrder";
import rwPaymentSuccessful from "../../components/pages/rewards/rwPaymentSuccessful";
import contactUs from "../../components/pages/contactUs";
//import {mapState} from 'vuex';

//import store from '../../store'

// eslint-disable-next-line no-undef
//console.log('store router-->', store.getters["settingsAndCustomize/configurationSite"], store.getters["settingsAndCustomize/configurationSite"].urlSubdomain, this.$subdomain)
export default [
    {
        path        : '/',
        name        : 'home',
        component   : home,
    },
    {
        path        : '/donate-blood',
        name        : 'donateBlood',
        component   : donateBlood,
        props       : (route) => ({ query: route.params.q }),
        query       : (route) => ({ query: route.query.q }),
    },
    {
        path        : '/donate-blood/choice-donation-location',
        name        : 'dbChoiceDonationLocation',
        component   : dbChoiceDonationLocation,
        meta : {
            triggerDonationLocation: true,
            redirectName: 'donateBlood'
        }
    },
    {
        path        : '/donate-blood/booking-appointment',
        name        : 'dbBookingAppointment',
        component   : dbBookingAppointment,
        meta : {
            triggerBookingAppointment: true,
            redirectName: 'donateBlood'
        }
    },
    {
        path        : '/my-donations',
        name        : 'myDonations',
        component   : myDonations,
        meta: {
            donorAuth:      true,
            redirectName:   'loginDonor'
        }
    },
    {
        path        : '/previous-donations',
        name        : 'previousDonations',
        component   : previousDonations,
        meta: {
            donorAuth:      true,
            redirectName:   'loginDonor'
        }
    },
    {
        path        : '/rewards-store',
        name        : 'rewardsStore',
        component   : rewardsStore,
    },
    {
        path        : '/rewards-store/description-order',
        name        : 'rwDescriptionOrder',
        component   : rwDescriptionOrder,
    },
    {
        path        : '/rewards-store/order',
        name        : 'rwOrder',
        component   : rwOrder,
    },
    {
        path        : '/rewards-store/payment-successful',
        name        : 'rwPaymentSuccessful',
        component   : rwPaymentSuccessful,
    },
    {
        path        : '/contact-us',
        name        : 'contactUs',
        component   : contactUs,
    }
]